import request from '@/common/request'

class NotaFiscalService {
  getAllItens(params) {
    return request.get('/notas-fiscais/itens', {
      params
    })
  }
}

export default new NotaFiscalService()
